import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hulk-config-poplist-edit',
  templateUrl: './hulk-config-poplist-edit.component.html',
  styleUrls: ['./hulk-config-poplist-edit.component.scss']
})
export class HulkConfigPoplistEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
